<template>
  <div class="medium-12">
    <div class="margin-b-xs">
      <label class="field-checkbox">
        <input type="checkbox" v-on:click="showHideForm" v-on:change="signupFlagChange" v-model="inputSignupFlag" class="margin-r-xs" v-show="false" />
        <i class="fas fa-check-square chkbox fa-fw" v-if="!isHidden"></i>
        <i class="far fa-square fa-fw" v-else></i>
        {{ $t('customerForm.createAccnt') }}
      </label>
    </div>
    <div ref="PasswordForm" v-bind:class="['password-form showhide-fadeslide', (isHidden? 'hide' : '')]">
      <form :class="['padding-a-m', isSafari]" data-vv-scope="password-form">
        <div class="row">
          <div class="medium-6 column padding-r-s small-padding-h-z">
            <div :class="{'field-group':true, 'field-error': errors.has('password-form.repassword')}">
              <label class="field-label">{{ $t('common.password') }}</label>
              <input type="password" name="password" placeholder="Password" class="field-text" v-model="password" @keyup="checkPasswordMatch" ref="password" />
            </div>
          </div>
          <div class="medium-6 columns padding-l-s small-padding-h-z">
            <div :class="{'field-group':true, 'field-error': errors.has('password-form.repassword')}">
              <label class="field-label">{{ $t('common.rpassword') }}</label>
              <input type="password" name="repassword" placeholder="Password" class="field-text" v-model="repassword"  @keyup="checkPasswordMatch" />
              <span v-show="errors.has('password-form.repassword')" class="field-error-message">{{ errors.first('password-form.repassword') }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

export default {
  name: 'password-form',
  data () {
    return {
      isHidden: true,
      inputSignupFlag: false,
      password: '',
      repassword: '',
      isSafari: navigator.userAgent.indexOf('Edge') > -1 ? 'safari' : ''
    }
  },
  methods: {
    showHideForm: function () {
      this.isHidden = !this.isHidden
      this.$emit('clicked', !this.isHidden)
      if (!this.isHidden) {
        this.$refs.password.focus()
        this.$scrollTo(this.$refs.PasswordForm)
      } else {
        this.errors.items = []
      }
    },
    signupFlagChange: function () {
      this.$parent.$emit('signupFlagChange', { value: this.inputSignupFlag })
    },
    checkPasswordMatch: function (outsourceTrigger) {
      if (!this.repassword) {
        this.errors.add('password-form.repassword', this.$t('customerForm.passwordRequired'))
        return
      }
      if (this.repassword !== this.password) {
        this.$emit('valid', { match: false })
        this.errors.add('password-form.repassword', this.$t('customerForm.passwordNotMatch'))
        return
      }
      this.$emit('valid', { match: true, password: this.password })
      this.errors.remove('password-form.repassword')
    },
    forceHide: function () {
      if (this.inputSignupFlag) {
        this.showHideForm()
      }
      this.inputSignupFlag = false
    }
  },
  mounted () {
    let _rsvp = this.$store.state.reservation.leg1
    if (_rsvp.pickup && !_rsvp.pickup.title) {
      this.inputSignupFlag = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/Customer/PasswordForm.scss";
.field-checkbox{
  .far, .fas{
    margin-right: 3px;
    font-size: 15px;
    vertical-align: -1px;
  }
}
.fa-check-square.chkbox{
  color: #0075ff;
}
</style>



// WEBPACK FOOTER //
// PasswordForm.vue?efd4730e